import { Vector3 } from "three";
import { Bin } from "./types";

export const calcBoxCenter = (
  x: number[],
  y: number[],
  z: number[]
): [number, number, number] => {
  return [
    x.reduce((acc, item) => acc + item, 0) / 8,
    z.reduce((acc, item) => acc + item, 0) / 8,
    -y.reduce((acc, item) => acc + item, 0) / 8,
  ];
};

export const distanceTo = (bin: Bin, i1: number, i2: number) =>
  new Vector3(bin.x[i1], bin.y[i1], bin.z[i1]).distanceTo(
    new Vector3(bin.x[i2], bin.y[i2], bin.z[i2])
  );

export const calcBinDimensions = (bin: Bin) => {
  /**
   * Bin coordinates are rounded by this fraction digit and grouped
   * If this number is high, the amount of distinct groups (geometries) will increase, so does draw calls
   * If this number is minimal, geometries will be minimal but all bins looks like the first bin
   */
  const COORDINATE_FRACTION_DIGIT = 1;

  const dimensions = [
    distanceTo(bin, 0, 1), // x0,y0,z0 - x1,y1,z1
    distanceTo(bin, 0, 4),
    distanceTo(bin, 0, 2),
  ];

  return {
    dimensions: dimensions as [number, number, number],
    id:
      Number(dimensions[0]).toFixed(COORDINATE_FRACTION_DIGIT) +
      "_" +
      Number(dimensions[1]).toFixed(COORDINATE_FRACTION_DIGIT) +
      "_" +
      Number(dimensions[2]).toFixed(COORDINATE_FRACTION_DIGIT),
  };
};
